import React from 'react';
import MapTo from '../utils/mapto';
import styled from 'styled-components';

const ResourceContent = styled.div`
    > div p {
        color: #165f57;
    }
    > div {
        box-shadow: inset 0px 0px 50px 0px rgba(0, 0, 0, 0.05), 0px 20px 50px -20px rgba(0, 0, 0, 0.10);
        backdrop-filter: blur(50px);
        position: relative;
        isolation: isolate;
    }
    > div::before{
        content: "";
        position: absolute;
        inset: -1px;
        border-radius: 48px;
        padding: 1px;
        background: linear-gradient(140deg, #FFF 7.86%, rgba(92, 143, 137, 0.40) 12.11%, rgba(92, 143, 137, 0.40) 88.58%, #FFF 92.83%);
        mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        z-index: -1;
    }

    > div:nth-child(odd) {
        background: rgba(225, 233, 221, 0.7);
    }
    > div:nth-child(even) {
        background: rgba(122, 197, 147, 0.3);
    }

    @media (min-width: 1024px) {
        > div:nth-child(4n + 1),
        > div:nth-child(4n + 4) {
            background-color: rgba(225, 233, 221, 0.7);
        }

        > div:nth-child(4n + 2),
        > div:nth-child(4n + 3) {
            background-color: rgba(122, 197, 147, 0.3);
        }

        > div:nth-child(4n + 2)::before,
        > div:nth-child(4n + 3)::before{
            content: "";
            position: absolute;
            inset: -1px;
            border-radius: 48px;
            padding: 1px;
            background: linear-gradient(303deg, #FFF 7.86%, rgba(92, 143, 137, 0.40) 12.11%, rgba(92, 143, 137, 0.40) 88.58%, #FFF 92.83%);
            mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
            -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
            -webkit-mask-composite: xor;
            mask-composite: exclude;
            z-index: -1;
        }
    }
`;

const ResourcesBlock = (content) => {
    return content.content.items.length > 0 ? (
        <div className={`resources-block lg:mb-[100px] mb-12 ${content.content.title}`}>
            <h3 className="text-center text-p font-medium lg:text-h4_medium text-dark_green lg:mb-[50px] mb-6">{content.content.title} {	["Bariatric","Breast", "Colorectal/General", "Obstetrics/Gynecologic", "Oral/Maxillofacial", "Orthopedic", "Pediatric", "Plastic", "Spine"].includes(content.content.title)? "Surgery" :""}</h3>
            <ResourceContent className="resources-content flex flex-col lg:grid lg:grid-cols-2 gap-4">
                {content.content.items.map((item, index) => (
                    <MapTo key={index} items={item} />
                ))}
            </ResourceContent>
        </div>
    ) : (
            <div className={`resources-block mb-[100px] ${content.content.title}`}>
            <h3 className="text-center text-p font-medium lg:text-h4_medium text-dark_green mb-[50px]">"No Data Found"</h3>
        </div>
    );
};

export default ResourcesBlock;
